import { State } from '../../types';

export const connecticut: State = {
  name: 'Connecticut',
  abbreviation: 'CT',
  terms: [
    {
      word: 'Berlin',
      phonetic: 'BER-lin',
      // audioUrl: '/audio/berlin.mp3',
      description: 'Unlike the German capital, this town is pronounced with the emphasis on the first syllable.'
    },
    {
      word: 'Connecticut',
      phonetic: 'kuh-NEH-tih-kuht',
      audioUrl: '/audio/connecticut.mp3',
      description: 'State name pronunciation'
    },
    {
      word: 'Coventry',
      phonetic: 'CAH-ven-tree',
      // audioUrl: '/audio/coventry.mp3',
      description: 'This town\'s name is pronounced with a broad "a" sound in the first syllable.'
    },
    {
      word: 'Ledyard',
      phonetic: 'LED-yard',
      // audioUrl: '/audio/ledyard.mp3',
      description: 'Despite its spelling, this town\'s name is pronounced as it appears, with a clear "d" sound.'
    },
    {
      word: 'Mashamoquet',
      phonetic: 'mash-MUH-kit',
      // audioUrl: '/audio/mashamoquet.mp3',
      description: 'A state park in Pomfret, its name is derived from a Native American word meaning "important fishing place."'
    },
    {
      word: 'Moosup',
      phonetic: 'MOO-sup',
      // audioUrl: '/audio/moosup.mp3',
      description: 'A village in Plainfield, the name is pronounced with a long "oo" sound.'
    },
    {
      word: 'Norwich',
      phonetic: 'NOR-wich',
      // audioUrl: '/audio/norwich.mp3',
      description: 'The "w" is silent in this town\'s name, similar to its namesake in England.'
    },
    {
      word: 'Quinebaug',
      phonetic: 'KWIN-uh-bawg',
      audioUrl: '/audio/quinebaug.mp3',
      description: 'River and region in eastern Connecticut'
    },
    {
      word: 'Southington',
      phonetic: 'SUTH-ing-ton',
      // audioUrl: '/audio/southington.mp3',
      description: 'The "o" is pronounced as a short "u" sound, and the "th" is voiced.'
    },
    {
      word: 'Thames',
      phonetic: 'TEMZ',
      // audioUrl: '/audio/thames.mp3',
      description: 'The river\'s name is pronounced like the one in London, with a silent "h" and a short "e" sound.'
    }
  ]
};